import { render, staticRenderFns } from "./BloodSugarTrendChart.vue?vue&type=template&id=72cc04b8"
import script from "./BloodSugarTrendChart.vue?vue&type=script&lang=js"
export * from "./BloodSugarTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports